import {
  TravellerPayment,
  TRAVELLER_PAYMENT_DETAILS,
  INITIATE_TOKEN,
  RESET_PAYMENT_STORE,
  SET_PAYMENT_TOKEN,
  RESET_PAYMENT_TOKEN_STATE
} from './types';
import { Dispatch } from 'redux';
import { get } from 'lodash';
import { checkTrue } from '@trip-ux/common';

export const setPayment =
  (payload: TravellerPayment) =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: TRAVELLER_PAYMENT_DETAILS,
      payload
    });
  };

export const resetPaymentTokenState = 
() => 
  (dispatch: Dispatch): void => {
  dispatch({
    type: RESET_PAYMENT_TOKEN_STATE
  });
};

export const initiateToken =
  payload =>
  (dispatch: Dispatch): void => {
    const { individualPayment, travellerCount, values } = payload;
    let cardHolderName = {};
    let i = 1;

    if (checkTrue(individualPayment)) {
      for (i; i <= travellerCount; i++) {
        cardHolderName = { ...cardHolderName, [`cardHolderName${i}`]: get(values, `cardHolderName${i}`) };
      }
    } else {
      cardHolderName = { [`cardHolderName${i}`]: get(values, `cardHolderName${i}`) };
    }

    dispatch({
      type: INITIATE_TOKEN,
      cardHolderName
    });
  };

export const resetPayment =
  () =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: RESET_PAYMENT_STORE
    });
  };

export const setPaymentToken =
  payload =>
  (dispatch: Dispatch): void => {
    dispatch({
      type: SET_PAYMENT_TOKEN,
      payload
    });
  };
